export default __webpack_public_path__ + "static/media/ImageLeft.c135c829.svg";